<section class="login-section">
    <div class="login-section-inner">
        <div class="login-left">
            <h2>Hello!</h2>
            <div class="login-acc">
                Please complete to create your account.
            </div>
        </div>
        <div class="login-right">
            <div>
                <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
                    <div class="row">

                        <div class="col-md-12 text-center mb-3">
                            <img src="../../../../assets/images/enl-solutions-logo-new.png" class="login-logo enl-logo">
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="section-relative input-name">
                                    <input type="text" formControlName="firstName" class="form-control" id="Inputtext"
                                        aria-describedby="textHelp" placeholder="First Name">
                                    <img src="../../../../assets/images/user.svg" class="user-icon">

                                    <div *ngIf="hasError('firstName', 'required') && submitted"
                                        class="invalid-Validation">
                                        First Name is required
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="section-relative input-name">
                                    <input type="text" formControlName="lastName" class="form-control" id="Inputtext"
                                        aria-describedby="textHelp" placeholder="Last Name">
                                    <img src="../../../../assets/images/user.svg" class="user-icon">
                                    <div *ngIf="hasError('lastName', 'required') && submitted"
                                        class="invalid-Validation">
                                        Last Name is required
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="section-relative">
                                    <input type="text" formControlName="password" class="form-control" id="exampleInputPassword1"
                                        placeholder="Password" (keyup)="checkPasswords()">

                                    <img src="../../../../assets/images/password.svg" class="user-icon pass-icon">

                                    <div *ngIf="hasError('password', 'required') && submitted"
                                        class="invalid-Validation">
                                        Password is required
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="section-relative">
                                    <input type="text" formControlName="confirmPassword" class="form-control"
                                        id="exampleInputPassword1" placeholder="Confirm Password" (keyup)="checkPasswords()">

                                    <img src="../../../../assets/images/password.svg" class="user-icon pass-icon">

                                    <div *ngIf="hasError('confirmPassword', 'required') && submitted"
                                        class="invalid-Validation">
                                        Confirm Password is required
                                    </div>
                                    <div *ngIf="confirmPassNotSame" class="invalid-Validation">
                                        Confirm Password not match with password
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 password-info">
                          <p>Passwords must contain at least eight characters.
                          </p>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="section-relative">
                                    <input type="text" formControlName="companyName" class="form-control" id="Inputtext"
                                        aria-describedby="textHelp" placeholder="Company Name">
                                    <img src="../../../../assets/images/company.svg" class="user-icon">

                                    <!-- <div *ngIf="hasError('companyName', 'required') && submitted"
                                        class="invalid-Validation">
                                        Company Name is required
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="section-relative">
                                    <input type="email" formControlName="email" class="form-control" id="InputEmail"
                                        aria-describedby="emailHelp" placeholder="Email" (blur)="checkEmailExist()">
                                    <img src="../../../../assets/images/envelope.svg" class="user-icon pass-icon-sec">

                                    <div *ngIf="hasError('email', 'required') && submitted" class="invalid-Validation">
                                        Email is required
                                    </div>
                                    <div *ngIf="hasError('email', 'email') && submitted" class="invalid-Validation">
                                        Invalid Email
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="col-md-6">
                            <div class="form-group">
                                <div class="section-relative input-name">
                                    <input type="text" formControlName="countryCode" maxLength="3" class="form-control"
                                        id="Inputtext" aria-describedby="textHelp" placeholder="Country Code"
                                        (keypress)="onKeyPress($event)">
                                    <img src="../../../../assets/images/globe.svg" class="user-icon">

                                    <div *ngIf="hasError('countryCode', 'required') && submitted"
                                        class="invalid-Validation">
                                        Country Code is required
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="section-relative input-name">
                                    <input type="text" formControlName="phoneNumber" maxLength="12" class="form-control"
                                        id="Inputtext" aria-describedby="textHelp" placeholder="Phone Number"
                                        (keypress)="onKeyPress($event)">
                                    <img src="../../../../assets/images/phone-numbers-call.svg" class="user-icon">

                                    <div *ngIf="hasError('phoneNumber', 'required') && submitted"
                                        class="invalid-Validation">
                                        Phone Number is required
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="section-relative input-name pRel">                                 
                                    <p-dropdown [options]="countries" formControlName="country"
                                        optionLabel="countryName" class="select-dropdown-sec" placeholder="Country"
                                        [virtualScroll]="true" [itemSize]="31" [filter]="false"></p-dropdown>
                                    <img src="../../../../assets/images/country.svg" class="user-icon pass-icon-sec">

                                    <div *ngIf="hasError('country', 'required') && submitted"
                                        class="invalid-Validation">
                                        Country Name is required
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="col-md-6"></div>
                        <div class="col-md-12">
                            <div class="remember-sec terms-sec">
                                <label class="container">
                                    <p-checkbox formControlName="termsAndConditions" binary="true"></p-checkbox>
                                    <span>
                                        I agree with terms and conditions
                                    </span>
                                    <!-- <input type="checkbox" formControlName="termsAndConditions">
                                    I agree with terms and conditions
                                    <span class="checkmark"></span> -->
                                </label>
                            </div>
                            <div *ngIf="hasError('termsAndConditions', 'required') && submitted"
                                class="invalid-Validation invalid-terms ">
                                terms and conditions is required
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="section-relative input-name">
                                    <re-captcha siteKey="6LdPwpYaAAAAAPu2F5S11m_D6ZnWMAbQaF95LSej" (onResponse)="showResponse($event)" (onExpire)="resetCaptcha($event)"></re-captcha>
                                </div>
                            </div>
                        </div>

                      
                        <div class="col-md-12">
                            <div class="btn-login-sec btn-reg-sec">
                                <button class="btn btn-signIn" type="submit">REGISTER</button>

                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="already-sign-sec">
                                <a routerLink="/login" class="already-sign">
                                    Already have an account? Sign In
                                </a>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="copyright-text">
                                Copyright 2021. All Rights Reserved.
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>
